import { createSlice } from '@reduxjs/toolkit';
import { IJob } from '../../../../dto';
import { setJob } from '../actions';
import { MN_JOBS, TYPE_ELEMENT } from '../../../../common';

export interface JobState {
  data: IJob | null;
  loading: boolean;
  error: string | null;
}

const initialState: JobState = {
  data: null,
  loading: false,
  error: null,
};

export const jobSlice = createSlice({
  name: `${MN_JOBS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setJob, (state, { payload }) => {
      state.data = payload;
    });
  },
});
